import { Board } from "./Board";

import { GameVars } from "../GameVars";

import { GameConstants } from "../GameConstants";

import { HelpLayer } from "../splash/help-layer/HelpLayer";

import { AudioManager } from "../AudioManager";

import { ChallengeManager } from "../challenge/ChallengeManager";

import { BoardManagerAI } from "./BoardManagerAI";

export class Piece extends Phaser.Group {

    public static PIECE_SPEED = .5;
    public static movementBlocked = false;

    public color: string;
    public pieceType: string;
    public p: string;
    public board: Board;
    public pieceSprite: Phaser.Sprite;
    public inCheck: boolean;
    public normalStateTextureName: string;

    private rays: Phaser.Sprite;
    private selectedPieceImage: Phaser.Image;
    private checkAlert: Phaser.Image;
    
    constructor(game: Phaser.Game, pieceType: string, board: Board) {

        super(game, null, "piece");

        this.pieceType = pieceType;
        this.board = board;
        this.inCheck = false;

        let pieceInfo: {textureName: string, color: string} = GameVars.getPieceInfo(this.pieceType);
        this.normalStateTextureName = pieceInfo.textureName;
        this.color = pieceInfo.color;

        this.rays = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "rays.png");
        this.rays.anchor.set(.5);
        this.rays.scale.set(.85);
        this.rays.visible = false;
        this.add(this.rays);

        if (this.pieceType === GameConstants.BLACK_KING || this.pieceType === GameConstants.WHITE_KING) {
            this.checkAlert = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "check_alert.png");
            this.checkAlert.anchor.set(.5);
            this.checkAlert.scale.set(0);
            this.checkAlert.visible = false;
            this.add(this.checkAlert);
        }

        this.selectedPieceImage = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "selected_piece.png");
        this.selectedPieceImage.anchor.set(.5);
        this.selectedPieceImage.visible = false;
        this.add(this.selectedPieceImage);

        this.pieceSprite = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", this.normalStateTextureName);
        this.pieceSprite.anchor.set(.5);

        this.add(this.pieceSprite);
    }

    public enableClick(): void {
        
        this.pieceSprite.inputEnabled = true;
        this.pieceSprite.events.onInputDown.add(this.onDown, this);
    }

    public disableClick(): void {
        
        this.pieceSprite.inputEnabled = false;
    }

    public setPosition(p: string, firstTime?: boolean, pieceKilled?: void, castling?: boolean): void {
        
        this.p = p;

        let column = p[0];
        let row = p[1];

        let c = GameConstants.COLUMNS.indexOf(column);
        let r = GameConstants.ROWS.indexOf(row);

        let x = GameConstants.SQUARE_WIDTH * (c - 3.5);
        let y = GameConstants.SQUARE_WIDTH * (r - 3.5);

        if (firstTime) {

            this.x = x;
            this.y = y;

        } else {

            this.unselect();
            let parent = <Phaser.Group> this.parent;
            parent.bringToTop(this);
            if (this.pieceType === GameConstants.BLACK_KNIGHT || this.pieceType === GameConstants.WHITE_KNIGHT) {
                this.moveKnight(x, y);
            } else {
                this.movePiece(x, y, castling);
            }
        }
    }

    public check(): void {

        this.inCheck = true;

        this.checkAlert.visible = true;

        this.game.add.tween(this.checkAlert.scale)
            .to({x: 1, y: 1}, 500, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {

                if (this.game) {
                    this.game.add.tween(this.checkAlert.scale)
                    .to({x: .9, y: .9}, 450, Phaser.Easing.Cubic.Out, true, 0, 1, true)
                    .onComplete.add(function(): void {

                        if (this.game) {
                            this.game.add.tween(this.checkAlert.scale)
                            .to({x: 0, y: 0}, 350, Phaser.Easing.Cubic.Out, true);
                        }
                        
                    }, this);
                }
                
            }, this);

        if (!HelpLayer.currentInstance) {
            let parent = <Phaser.Group> this.parent;
            parent.bringToTop(this);
        }
    }

    public uncheck(): void {

        this.inCheck = false;

        this.checkAlert.scale.set(0);
        this.checkAlert.visible = false;
    }

    public flash(): void {

        if (!this.game) {
            return;
        }

        this.rays.visible = true;

        this.game.add.tween(this.rays.scale)
            .to({x: 1.75, y: 1.75}, 200, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {
                this.rays.scale.set(.85);
                this.rays.visible = false;
            }, this);
    }

    public moveToPromotionPosition(p: string): void {

            // ponerla por encima de todo
        const parent = <Phaser.Group> this.parent;
        parent.bringToTop(this);
        
        const coordinates: {x: number, y: number} = GameVars.getCoordinatesFromPosition(p);

        const t = GameConstants.SQUARE_WIDTH / Piece.PIECE_SPEED;

        this.game.add.tween(this)
            .to( {x: coordinates.x , y: coordinates.y}, t, Phaser.Easing.Cubic.Out, true);
    }

    public promoteTo(promotedPiece: string): void {

        this.flash();

        // promoted piece va a venir siempre en minusculas
        switch (promotedPiece) {
                case GameConstants.BLACK_QUEEN:
                this.pieceType = this.color === GameConstants.WHITE ? GameConstants.WHITE_QUEEN : GameConstants.BLACK_QUEEN;
                break;

                case GameConstants.BLACK_ROOK:
                this.pieceType = this.color === GameConstants.WHITE ? GameConstants.WHITE_ROOK : GameConstants.BLACK_ROOK;
                break;
        
                case GameConstants.BLACK_BISHOP:
                this.pieceType = this.color === GameConstants.WHITE ? GameConstants.WHITE_BISHOP : GameConstants.BLACK_BISHOP;
                break;
        
            case GameConstants.BLACK_KNIGHT:
                this.pieceType = this.color === GameConstants.WHITE ? GameConstants.WHITE_KNIGHT : GameConstants.BLACK_KNIGHT;
                break;
        
            default:
                break;
        }

        let pieceInfo: {textureName: string, color: string} = GameVars.getPieceInfo(this.pieceType);
        this.normalStateTextureName = pieceInfo.textureName;

        this.pieceSprite.frameName = this.normalStateTextureName;
    }

    public kill(destroy?: boolean): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.scale)
            .to({x: .7, y: .7}, 300, Phaser.Easing.Cubic.Out, true);

        const alphaTween = this.game.add.tween(this)
                                .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true, 150);

        if (destroy) {
            
            alphaTween.onComplete.add(this.destroy, this);
            
            if (Math.random() > .5) {
                AudioManager.playSound("piece_killed_01");
            } else {
                AudioManager.playSound("piece_killed_02");
            }    
        } 
    }

    public reset(x: number, y: number): void {

        this.position.set(x, y);

        this.scale.set(1);
        this.alpha = 1;
        
        this.rays.scale.set(.85);
        this.rays.visible = false;
    }

    public unselect(): void {

        this.selectedPieceImage.visible = false;

        this.game.add.tween(this.pieceSprite.scale)
            .to({x: 1, y: 1}, 700, Phaser.Easing.Cubic.Out, true);
    }

    public select(): void {

        this.game.add.tween(this.pieceSprite.scale)
            .to({x: 1.2, y: 1.2}, 300, Phaser.Easing.Back.Out, true, 500)
            .onStart.add(function(): void {
                this.selectedPieceImage.visible = true;
            }, this);
    }

    public onDown(): void {
        
        if (this.color !== GameVars.colorPlayer || GameVars.getCurrentTurn() !== GameVars.colorPlayer || Piece.movementBlocked || GameVars.resigning) {
            return;
        }

        if (GameVars.challenge) {
            ChallengeManager.pieceSelected(this);
        } else if (GameVars.againstAI) {
            BoardManagerAI.pieceSelected(this);
        }

        this.selectedPieceImage.visible = true;

        this.game.add.tween(this.pieceSprite.scale)
            .to({x: 1.2, y: 1.2}, 300, Phaser.Easing.Back.Out, true);

        AudioManager.playSound("piece_selected");
    }

    private movePiece(x: number, y: number, castling?: boolean): void {
        // ponerla por encima de todo
        let parent: Phaser.Group = <Phaser.Group> this.parent;
        parent.bringToTop(this);
        // sacar la distancia usando el teorema de pitagoras
        let d = Math.sqrt((this.x - x) * (this.x - x) + (this.y - y) * (this.y - y));

        let t = d / Piece.PIECE_SPEED;

        // mover la pieza con un tween con duracion en funcion de la distancia
        if (GameVars.capturedPiece) {

            this.tiltCapturingPiece(x);
        }

        this.game.add.tween(this)
            .to({x: x, y: y}, t, Phaser.Easing.Cubic.Out, true, GameVars.capturedPiece ? 200 : 0)
            .onComplete.add(function(a: any, b: any, args: any): void {

                if (!args[0]) {
                    if (GameVars.challenge) {
                        ChallengeManager.onPieceArrivedToItsPosition();
                    } else if (GameVars.againstAI) {
                        BoardManagerAI.onPieceArrivedToItsPosition();
                    } 
                }

                if (GameVars.capturedPiece) {
                    this.game.add.tween(this.pieceSprite)
                        .to({x: 0, y: 0, angle: 0}, 300, Phaser.Easing.Bounce.Out, true);
                }

            }, this, 0, [castling]);

        AudioManager.playSound("piece_moved");
    }

    private moveKnight(x: number, y: number): void {

        let dx = Math.abs(this.x - x);
        let tx = dx / Piece.PIECE_SPEED;

        let dy = Math.abs(this.y - y);
        let ty = dy / Piece.PIECE_SPEED;

        if (GameVars.capturedPiece) {

            this.tiltCapturingPiece(x);
        }

        if (dx > dy) {
                this.game.add.tween(this)
                .to({x: x}, tx, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function(a: any, b: any, c: number[]): void {

                    let y = c[0];
                    let ty = c[1];

                    this.game.add.tween(this)
                        .to({y: y}, ty, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(function(): void {

                            if (GameVars.challenge) {
                                ChallengeManager.onPieceArrivedToItsPosition();
                            } else if (GameVars.againstAI) {
                                BoardManagerAI.onPieceArrivedToItsPosition();
                            }

                            if (GameVars.capturedPiece) {
                                this.game.add.tween(this.pieceSprite)
                                    .to({x: 0, y: 0, angle: 0}, 300, Phaser.Easing.Bounce.Out, true);
                            }
                        }, this);

                }, this, 0, [y, ty]);
        } else {
                this.game.add.tween(this)
                .to({y: y}, ty, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function(a: any, b: any, c: number[]): void {

                    let x = c[0];
                    let tx = c[1];

                    this.game.add.tween(this)
                        .to({x: x}, tx, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(function(): void {

                            if (GameVars.challenge) {
                                ChallengeManager.onPieceArrivedToItsPosition();
                            } else if (GameVars.againstAI) {
                                BoardManagerAI.onPieceArrivedToItsPosition();
                            }

                            if (GameVars.capturedPiece) {
                                this.game.add.tween(this.pieceSprite)
                                    .to({x: 0, y: 0, angle: 0}, 300, Phaser.Easing.Bounce.Out, true);
                            }
                        }, this);

                }, this, 0, [x, tx]);
        }

        AudioManager.playSound("piece_moved");
    }

    private tiltCapturingPiece(end_x: number): void { 

        // darle a la pieza un angulo dependiendo de donde esta la pieza capturada
        // si la pieza esta a la izquierda de la que va a capturar
        if (this.x - end_x < 0) {
            this.pieceSprite.angle = 12;
            this.pieceSprite.x = -15;
        } else {
            this.pieceSprite.angle = -12;
            this.pieceSprite.x = 15;
        }

        if (GameVars.colorPlayer === GameConstants.BLACK) {
            this.pieceSprite.angle *= -1;
        }

        this.pieceSprite.y = -15;
    }
}
